export default __webpack_public_path__ + "static/logo-93df2c2583d4840cdb8982770d41431d.svg";